import { UsersOnlineActions, UsersOnlineActionTypes } from "./users-online.actions";
import { UsersOnline, initialState} from "./users-online.state";

export function usersOnlineReducer(state = initialState, action: UsersOnlineActions): UsersOnline {
    switch (action.type) {

    case UsersOnlineActionTypes.Connect:
        return { 
            ...state, 
            members: [...state.members.filter((uid: string) => action.userId !== uid), action.userId] 
        };

    case UsersOnlineActionTypes.Disconnect:
        return { 
            ...state, 
            members: state.members.filter((uid: string) => action.userId !== uid)
        };

    default:
        return state;
    }
}
